import templates from './templates'
import './index.styl';
import { redirectTo, Preloader } from '../../../../../core/utils';

import { CoreRegenerationRestartView } from '../../../../../core/views';

/**
 * @desc League Settings View Class
 * This class using on league settings page ('league/:league_id/regenerate/:league_old_id')
 */
export default class RegenerationRestartView extends CoreRegenerationRestartView {
	get template() {
		return templates.open;
	}

	getTemplate() {
		let type_league = this.model.get( 'origin_type' );

		if ( type_league === 'open' ) {
			return templates.open;
		}
		else {
			return templates.h2h;
		}
	}

	get className() {
		return "league-regeneration-page shadow";
	}

	regenerationLeagueSuccess() {
		Preloader.hide();
		let league_id = this.model.get( 'id' ),
			url       = `fantasy/league/${league_id}/regenerate/invite/${this.old_league_id}`;

		redirectTo( url );
	}
}